<template>
    <div id="wrap" v-loading="loading">
        <div class="flex flex-start">
            <div>
                <el-form :model="queryParams" ref="formQuery" :inline="true">
                    <el-form-item label="时间">
                        <el-date-picker
                                v-model="queryParams.time"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd"
                                @change="timeChange"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="handleQuery">搜索</el-button>
                        <el-button type="primary" @click="resetQuery">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="flex flex-end">
            <el-button type="primary" @click="handleAdd"
            >新增
            </el-button
            >
        </div>

        <el-table
                class="table"
                :data="datas"
                :header-cell-style="{ background: '#F5F7FA' }"
                stripe
                :row-class-name="tableRowClassName"
        >
            <el-table-column label="序号" width="60" prop="date">
                <template slot-scope="scope">
                    <span>{{ scope.$index + 1 }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="activityNumber" label="研发活动编号">
            </el-table-column>
            <el-table-column prop="activityName" label="研发活动名称">
            </el-table-column>
            <el-table-column
                    prop="tecField"
                    label="技术领域"
                    show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                    label="技术来源"
                    prop="tecSource"
            ></el-table-column>
            <el-table-column
                    label="近三年总支出"
                    show-overflow-tooltip
                    prop="totalExpenditrueLastThreeYears"
            ></el-table-column>
            <el-table-column label="操作" width="140">
                <template slot-scope="scope">
                    <el-button type="text" size="small" class="green" @click="handleUpdate(scope.row.id)">编辑</el-button>
                    <el-button type="text" size="small" class="red" @click="handleDelete(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="flex flex-end">
            <el-pagination
                    class="pagination"
                    background
                    v-show="total>0"
                    :total="total"
                    :current-page.sync="queryParams.pageNum"
                    :page-size.sync="queryParams.pageSize"
                    @current-change="getList"
            >
            </el-pagination>
        </div>


        <!-- 弹框 -->
        <el-dialog
                title="企业研究开发活动情况表"
                :visible.sync="centerDialogVisible"
                width="66%"
                center
                v-loading="loading"
        >

            <el-form
              v-loading="loading"
                    :model="formData"
                    :rules="rules"
                    ref="ruleForm"
                    class="demo-ruleForm"
            >
                <div>
                    <el-row class="flex flex-justify">
                        <el-col :span="12">
                            <el-form-item
                                    label="企业研发活动编号:RD"
                                    prop="enterpriseDevelopmentsActivitiesBO.activityNumber"
                                    label-width="40%"
                            >
                                <el-input v-model="formData.enterpriseDevelopmentsActivitiesBO.activityNumber"
                                          :maxlength="inputMax"
                                          placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-col>

                        <el-col :span="12">
                            <el-form-item
                                    label="研发活动名称"
                                    prop="enterpriseDevelopmentsActivitiesBO.activityName"
                                    label-width="20%"
                            >
                                <el-input style="width:80%"
                                        :maxlength="inputMax" v-model="formData.enterpriseDevelopmentsActivitiesBO.activityName"
                                          placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row class="flex flex-justify">
                        <el-col :span="12">
                            <el-form-item label="开始日期" prop="enterpriseDevelopmentsActivitiesBO.startTime"
                                          label-width="40%">
                                <el-date-picker :editable="false" value-format="yyyy-MM-dd"
                                                :picker-options="pickerOptions"
                                                v-model="formData.enterpriseDevelopmentsActivitiesBO.startTime"
                                                placeholder="请选择"></el-date-picker>
                            </el-form-item>
                        </el-col>

                        <el-col :span="12">
                            <el-form-item label="结束日期" prop="enterpriseDevelopmentsActivitiesBO.endTime"
                                          label-width="20%">
                                <el-date-picker style="width:80%" :editable="false" value-format="yyyy-MM-dd"
                                                :picker-options="endPickerOptions"
                                                v-model="formData.enterpriseDevelopmentsActivitiesBO.endTime"
                                                placeholder="请选择"></el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row type="flex" justify="space-between">
                        <el-col :span="24">
                            <el-form-item label="技术领域" :required="true" label-width="20%">
                                <div class="select_box">
                                    <el-form-item prop="enterpriseDevelopmentsActivitiesBO.tecFieldFirst">
                                        <el-select v-model="formData.enterpriseDevelopmentsActivitiesBO.tecFieldFirst"
                                                   @change="tecFieldCchange">
                                            <el-option
                                                    v-for="dict in tecFieldFirst"
                                                    :key="dict.id"
                                                    :label="dict.dictName"
                                                    :value="dict.dictCode"
                                                    placeholder="请选择"
                                            ></el-option>
                                        </el-select>
                                    </el-form-item>

                                    <el-form-item prop="enterpriseDevelopmentsActivitiesBO.tecFieldSecond">
                                        <el-select v-model="formData.enterpriseDevelopmentsActivitiesBO.tecFieldSecond"
                                                   @change="tecFieldSecondCchange">
                                            <el-option
                                                    v-for="dict in tecFieldSecond"
                                                    :key="dict.id"
                                                    :label="dict.dictName"
                                                    :value="dict.dictCode"
                                                    placeholder="请选择"
                                            ></el-option>
                                        </el-select>
                                    </el-form-item>

                                    <el-form-item prop="enterpriseDevelopmentsActivitiesBO.tecFieldThird">
                                        <el-select v-model="formData.enterpriseDevelopmentsActivitiesBO.tecFieldThird">
                                            <el-option
                                                    v-for="dict in tecFieldThird"
                                                    :key="dict.id"
                                                    :label="dict.dictName"
                                                    :value="dict.dictCode"
                                                    placeholder="请选择"
                                            ></el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row class="flex">
                        <el-col :span="12">
                            <el-form-item label="技术来源" prop="enterpriseDevelopmentsActivitiesBO.tecSource"
                                          label-width="40%">
                                <el-select v-model="formData.enterpriseDevelopmentsActivitiesBO.tecSource">
                                    <el-option
                                            v-for="dict in technologySource"
                                            :key="dict.id"
                                            :label="dict.dictName"
                                            :value="dict.dictCode"
                                            placeholder="请选择"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row class="flex">
                        <el-col :span="12">
                            <el-form-item
                                    label="研发经费总预算(万元) "
                                    prop="enterpriseDevelopmentsActivitiesBO.researchBudget"
                                    label-width="40%"
                            >
                                <el-input-number :max="999999999999999"
                                        v-model="formData.enterpriseDevelopmentsActivitiesBO.researchBudget"
                                        :controls="false"
                                        placeholder="请输入"

                                ></el-input-number>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row class="flex">
                        <el-col :span="24">
                            <el-form-item
                                    label="知识产权编号"
                                    prop="name"
                                    label-width="20%"
                            >
                                <el-transfer :titles="['未选数据','已选数据']" v-model="formData.intellectualPropertyIds"
                                             :data="zscpData"></el-transfer>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="24">
                            <p style="margin-left: 4.5%">研发费用近三年总支出(万元)</p>
                        </el-col>
                    </el-row>

                              <el-row class="flex flex-justify">
                                <el-col :span="12">
                                  <el-form-item
                                    label="总计：(万元)"
                                    prop="enterpriseDevelopmentsActivitiesBO.totalExpenditrueLastThreeYears"
                                    label-width="40%"
                                  >
                                <el-input-number :disabled="true"
                                                 v-model="formData.enterpriseDevelopmentsActivitiesBO.totalExpenditrueLastThreeYears"
                                                 :controls="false" placeholder="请输入" maxlength="20" minlength="1" ></el-input-number>
                            </el-form-item>
                        </el-col>

                        <el-col :span="12">
                            <el-form-item :label="years[0]" prop="thirdYear" label-width="20%">
                                <el-input-number style="width:80%" v-model="formData.thirdYear" :controls="false" @change="yearsChange"
                                           :max="999999999999999"      placeholder="请输入" maxlength="20" minlength="1" ></el-input-number>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row class="flex flex-justify">
                        <el-col :span="12">
                            <el-form-item :label="years[1]" prop="secondYear" label-width="40%">
                                <el-input-number :max="999999999999999"
                                                 @change="yearsChange"
                                        v-model="formData.secondYear"
                                        :controls="false"
                                        placeholder="请输入" maxlength="20" minlength="1"
                                ></el-input-number>
                            </el-form-item>
                        </el-col>

                        <el-col :span="12">
                            <el-form-item :label="years[2]" prop="firstYear" label-width="20%">
                                <el-input-number :max="999999999999999"
                                                 style="width:80%"
                                        @change="yearsChange"
                                        v-model="formData.firstYear"
                                        :controls="false"
                                        placeholder="请输入" maxlength="20" minlength="1"
                                ></el-input-number>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <div class="wrap">
                        <el-row>
                          <el-col :span="24">
                            <el-form-item label-width="20%" prop="enterpriseDevelopmentsActivitiesBO.purposeMethod"
                                          :label="'目的及组织实施方式\n(限400字以内)'">
                              <el-input style="width:90%" type="textarea" maxlength="400" show-word-limit :rows="4"
                                        v-model="formData.enterpriseDevelopmentsActivitiesBO.purposeMethod"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :sapn="24">
                            <el-form-item label-width="20%" prop="enterpriseDevelopmentsActivitiesBO.technologyInnovation"
                                          :label="'核心技术及创新点\n(限400字以内)'">
                              <el-input style="width:90%" type="textarea" maxlength="400" show-word-limit :rows="4"
                                        v-model="formData.enterpriseDevelopmentsActivitiesBO.technologyInnovation"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :sapn="24">
                            <el-form-item label-width="20%" prop="enterpriseDevelopmentsActivitiesBO.periodicalAchievement"
                                          :label="'取得的阶段性成果\n(限400字以内)'">
                              <el-input style="width:90%" type="textarea" maxlength="400" show-word-limit :rows="4"
                                        v-model="formData.enterpriseDevelopmentsActivitiesBO.periodicalAchievement"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <br/>
                    </div>

                    <div class="wrap" style="width: 90%;margin-left: 10%">
                        <p>
                            科研项目立项证明
                        </p>
                        <el-upload
                                ref="upload"
                                class="upload-demo"
                                :action="uploadImgUrl"
                                accept=".pdf"
                                :on-success="quillImgSuccess"
                                :on-preview="handleView"
                                :on-remove="handleRemove"
                                :on-error="uploadError"
                                :before-remove="beforeRemove"
                                :before-upload="beforeUpload"
                                :data="{'moduleType':4}"
                                :file-list="fileList">
                            <el-button size="small" type="primary">点击上传</el-button>
                        </el-upload>
                        <div style="margin-left: 20px">
                            <p>
                                请上传科研项目立项证明(已验收或结题项目需附验收后结题报告)相关材料。
                            </p>
                            <p>附件格式要求:</p>
                            <p>1、证明材料扫描上传</p>
                            <p>2、只支持非加密PDF格式的文件上传</p>
                            <p>3、单个文件大小不要超过2M</p>
                        </div>
                    </div>
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
          <el-button @click="centerDialogVisible = false" v-loading="loading">返回</el-button>
          <el-button type="primary" @click="classSubmitForm"  :disabled="disabled" v-loading="loading"
          >保存</el-button
          >
      </span>
        </el-dialog>
    </div>
</template>

<script>
import {
    getDict,
    queryDictDataByTypeAndCode,
    getModuleFiles,
    enterpriseDevelopmentActivityQueryAll,
    enterpriseDevelopmentActivityQueryAllProperty,
    enterpriseDevelopmentActivityQuery,
    enterpriseDevelopmentActivitySave,
    enterpriseDevelopmentActivityDelete
} from '@/api/ChinaHigh'
import {getLastThreeYears} from '@/api/specialization'

export default {
    name: "enterprise",
    props: {
        id: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            rmModuleId:"",
            // 数据
            datas: [],
            total: 0,
            loading:false,
            // 弹框
            centerDialogVisible: false,
            queryParams: {},
            formData: {
                enterpriseDevelopmentsActivitiesBO: {},
                fileBOList: [],
            },
            rules: {
                'enterpriseDevelopmentsActivitiesBO.tecFieldFirst': [{
                    required: true,
                    message: "请选择技术领域",
                    trigger: "change"
                }],
                'enterpriseDevelopmentsActivitiesBO.tecFieldSecond': [{
                    required: true,
                    message: "请选择技术领域",
                    trigger: "change"
                }],
                'enterpriseDevelopmentsActivitiesBO.tecFieldThird': [{
                    required: true,
                    message: "请选择技术领域",
                    trigger: "change"
                }],
                'enterpriseDevelopmentsActivitiesBO.activityNumber': [{
                    required: true,
                    message: "请输入研发活动编号",
                    trigger: "blur"
                }],
                'enterpriseDevelopmentsActivitiesBO.activityName': [{
                    required: true,
                    message: "请输入研发活动名称",
                    trigger: "blur"
                }],
                'enterpriseDevelopmentsActivitiesBO.startTime': [{
                    required: true,
                    message: "请选择开始时间",
                    trigger: "change"
                }],
                'enterpriseDevelopmentsActivitiesBO.endTime': [{required: true, message: "请选择结束时间", trigger: "change"}],
                'enterpriseDevelopmentsActivitiesBO.tecSource': [{
                    required: true,
                    message: "请选择技术来源",
                    trigger: "change"
                }],
                'enterpriseDevelopmentsActivitiesBO.researchBudget': [{
                    required: true,
                    message: "请输入研发费用",
                    trigger: "change"
                }],
                'enterpriseDevelopmentsActivitiesBO.totalExpenditrueLastThreeYears': [{
                    required: true,
                    message: "请输入近三年总支出",
                    trigger: "blur"
                }],
                'thirdYear': [{required: true, message: "请输入", trigger: "blur"}],
                'secondYear': [{required: true, message: "请输入", trigger: "blur"}],
                'firstYear': [{required: true, message: "请输入", trigger: "blur"}],
                // 'enterpriseDevelopmentsActivitiesBO.purposeMethod': [ {required: true, message: "请输入目的及组织实施方式", trigger: "blur"} ],
                // 'enterpriseDevelopmentsActivitiesBO.technologyInnovation': [ {required: true, message: "请输入核心技术及创新点", trigger: "blur"} ],
                // 'enterpriseDevelopmentsActivitiesBO.periodicalAchievement': [ {required: true, message: "请输入取得的阶段性成果", trigger: "blur"} ],
            },
            fileList: [],
            tecFieldFirst: {},
            tecFieldSecond: {},
            tecFieldThird: {},
            // 技术来源
            technologySource: {},
            //日期限制
            pickerOptions: {
                disabledDate: time => {
                    let beginDateVal = this.formData.enterpriseDevelopmentsActivitiesBO.endTime;
                    if (beginDateVal) {
                        return (
                                time.getTime() >
                                new Date(beginDateVal).getTime()
                        );
                    }
                    // return time.getTime() > Date.now()
                }
            },
            endPickerOptions: {
                disabledDate: time => {
                    let beginDateVal = this.formData.enterpriseDevelopmentsActivitiesBO.startTime;
                    if (beginDateVal) {
                        return (
                                new Date(beginDateVal).getTime() >
                                time.getTime() + 8 * 60 * 60 * 1000
                        );
                    }
                },
            },
            zscpData: [],
            years: [],
            disabled: false
        };
    },
    created() {
        this.resetQuery();
        // this.handleUpdate();
    },
    methods: {
        chushi() {
            this.zscpData = []
            // 技术领域1
            getDict({"type": "technical_field", 'parentId': 0}).then(res => {
                this.tecFieldFirst = res.data;
            })
            // 技术来源
            getDict({"type": "technology_source", 'parentId': 0}).then(res => {
                this.technologySource = res.data;
            })
            enterpriseDevelopmentActivityQueryAllProperty(this.id).then(res => {
                res.data.forEach(re => {
                    console.log(re)
                    this.zscpData.push({
                        key: re.id,
                        label: re.intellectualNumber
                    })
                })
            })
            getLastThreeYears().then(res => {
                this.years = ['其中 (' + res.data[0] + ')', '其中 (' + res.data[1] + ')', '其中 (' + res.data[2] + ')']
            })
            this.formData = {
                enterpriseDevelopmentsActivitiesBO: {},
                fileBOList: [],
                intellectualPropertyIds: []
            }
            this.fileList = []
            this.resetFiles('upload');
            this.resetForm('ruleForm');
        },
        tableRowClassName({row, rowIndex}) {
            if ((rowIndex + 1) % 2 === 0) {
                return "background:#fff";
            } else {
                return "background:#F5F7FA";
            }
        },
        beforeRemove(file,fileList){
            // console.log(file.moduleId);
            this.rmModuleId=file.moduleId;
        },
        /** 列表 */
        getList() {
            this.loading = true
            enterpriseDevelopmentActivityQueryAll(this.queryParams).then(res => {
                this.datas = res.data.records
                this.total = res.data.total
                this.loading = false
            })
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.approvalId = this.id;
            this.queryParams.pageNum = 1;
            this.queryParams.pageSize = 10;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.resetForm('formQuery');
            this.queryParams = {};
            this.handleQuery();
        },
        // 日期选择
        timeChange(val) {
            this.queryParams.startTime = val[0] + ' 00:00:00';
            this.queryParams.endTime = val[1] + ' 23:59:59';
        },
        handleAdd() {
            this.chushi();
             this.formData = {
                enterpriseDevelopmentsActivitiesBO: {},
                fileBOList: [],
                intellectualPropertyIds: []
            }
            this.centerDialogVisible = true;
        },
        handleUpdate(id) {
            this.chushi();
            enterpriseDevelopmentActivityQuery(id, this.id).then(res => {
                if (res.data.enterpriseDevelopmentsActivitiesBO.tecFieldFirst !== '' && res.data.enterpriseDevelopmentsActivitiesBO.tecFieldFirst !== null) {
                    this.jishu(res.data.enterpriseDevelopmentsActivitiesBO.tecFieldFirst, 1, 2);
                }
                if (res.data.enterpriseDevelopmentsActivitiesBO.tecFieldSecond !== '' && res.data.enterpriseDevelopmentsActivitiesBO.tecFieldSecond !== null) {
                    this.jishu(res.data.enterpriseDevelopmentsActivitiesBO.tecFieldSecond, 2, 2);
                }
                this.formData.enterpriseDevelopmentsActivitiesBO = res.data.enterpriseDevelopmentsActivitiesBO;
                this.formData.intellectualPropertyIds = res.data.intellectualPropertyIds;
                this.formData.firstYear = res.data.firstYear;
                this.formData.secondYear = res.data.secondYear;
                this.formData.thirdYear = res.data.thirdYear;
                getModuleFiles({
                    'moduleId': res.data.enterpriseDevelopmentsActivitiesBO.id,
                    'moduleType': 4
                }).then(res => {
                    this.formData.fileBOList = res.data;

                    res.data.forEach(re => {
                        this.fileList.push({
                            "name": re.fileName,
                            "fileName": re.fileName,
                            "url": re.url,
                            "moduleId": re.moduleId,
                            "moduleType": re.moduleType,
                            "path": re.path,
                            'id': re.id
                        })
                    })
                })
                this.centerDialogVisible = true;
            })
        },
        handleDelete(id) {
            var that = this;
            this.$confirm("是否确认删除项目?", "警告", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                    .then(function () {
                        return enterpriseDevelopmentActivityDelete({"approvalId": that.id, "ids": [id]});
                    })
                    .then(() => {
                        this.getList();
                        this.msgSuccess("删除成功");
                    })
                    .catch(function () {
                    });
        },
        classSubmitForm() {
            this.formData.enterpriseDevelopmentsActivitiesBO.approvalId = this.id
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    enterpriseDevelopmentActivitySave(this.formData).then(res => {
                        if (res.code === "00000") {
                            this.handleQuery();
                            this.centerDialogVisible = false;
                            this.msgSuccess(res.msg);
                        }
                    })
                } else {
                    return false;
                }
            })
        },
        tecFieldCchange(val) {
            this.jishu(val, 1, 1)
        },
        tecFieldSecondCchange(val) {
            this.jishu(val, 2, 1)
        },
        // 技术领域
        jishu(val, type, stauts) {
            queryDictDataByTypeAndCode({'code': val, 'type': 'technical_field'}).then(res => {
                console.log(res);
                if (type == 1) {
                    if (stauts == 1) {
                        this.tecFieldThird = {};
                        this.$set(this.formData.enterpriseDevelopmentsActivitiesBO, 'tecFieldSecond', '');
                        this.$set(this.formData.enterpriseDevelopmentsActivitiesBO, 'tecFieldThird', '');
                    }
                    this.tecFieldSecond = res.data;
                } else {
                    if (stauts == 1) {
                        this.$set(this.formData.enterpriseDevelopmentsActivitiesBO, 'tecFieldThird', '');
                    }
                    this.tecFieldThird = res.data;
                }
            })
        },
        // 上传成功
        quillImgSuccess(res, file, fileList) {
            this.loading=false;
            // 如果上传成功
            if (res.code === '00000') {
                this.formData.fileBOList.push(res.data);
                this.msgSuccess("附件上传成功");
            } else {
                this.msgError("附件上传失败");
            }

            let status = ''
            fileList.some(res => {
                if(res.status != 'success'){
                    status = 1;
                    return ;
                }
            })
            if (status != 1) {
                this.disabled = false
            }
        },
        // 图片删除
        handleRemove(file, fileList) {
            this.formData.fileBOList = []
            fileList.forEach(res => {
                if (res.response == undefined) {
                    this.formData.fileBOList.push(res)
                } else {
                    this.formData.fileBOList.push(res.response.data)
                }
            })
            if (this.formData.fileBOList.length<=0){
                this.formData.fileBOList.push({moduleId:this.rmModuleId,moduleType:"4"})
            }
        },
        // 富文本图片上传失败
        uploadError(err, file, fileList) {
            this.loading=false;
            if(fileList.length> 0) {
                let status = ''
                fileList.some(res => {
                    if(res.status != 'success'){
                        status = 1;
                        return ;
                    }
                })
                if (status != 1) {
                    this.disabled = false
                }
            } else {
                this.disabled = false;
            }
            // loading动画消失
            this.msgError("图片上传失败");
        },
        beforeUpload(file) {
            var testmsg = file.name.substring(file.name.lastIndexOf('.')+1);
            const extension = testmsg === 'pdf';
            const isLt2M = file.size / 1024 /1024 <= 2;
            if(!extension) {
                this.msgError('上传文件只能是pdf文件');
                return false;
            }

            if(!isLt2M) {
                this.msgError('上传文件大小不能超过2M');
                return false;
            }
            // this.loading=true;
            // console.log(this.loading)
        },
        yearsChange() {
            this.$set(this.formData.enterpriseDevelopmentsActivitiesBO, 'totalExpenditrueLastThreeYears', Number(this.formData.thirdYear) + Number(this.formData.secondYear) + Number(this.formData.firstYear));

        }
    }
}
</script>

<style scoped>

.flex .el-button {
    margin-bottom: 10px;
}

.select_box {
  width: 64%;
    display: flex;
    justify-content: space-between;
}

.select_box .el-select,
.select_box .el-date-editor,
.select_box .el-input,
.select_box > div {
    width: 90%;
}

.textarea {
    width: 90%;
    height: 164px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    resize: none;
}
/deep/ .el-form-item__label{
  white-space:pre-line;
}
</style>
